/**
 * @see https://stackoverflow.com/questions/9038625/detect-if-device-is-ios#answer-9039885
 * @type {boolean} - 현재 기기가 iOS일 경우 true를 반환한다.
 */
const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export default iOS;
